import React, { useState, useEffect } from "react";
import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Select,
    MenuItem,
    FormControl,
    Typography,
    TextField,
    IconButton,
    InputLabel,
    Tabs,
    Tab,
    Paper,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import SaveIcon from "@material-ui/icons/Save";
import DeleteIcon from "@material-ui/icons/Delete";
import { green, red } from "@material-ui/core/colors";
import banStyles from "./BanArrivals.module.css";

const BanArrivals = (props) => {
    const activeRates = props.rates.filter((r) => r.active);
    const activeRoomTypes = props.roomTypes.filter((r) => r.active);

    let firstRoomTypeId =
        props.data?.roomTypeId?.split(",") ??
        (activeRoomTypes.length > 0 ? [activeRoomTypes[0].id] : []);
    let firstRateId =
        props.data?.rateId?.split(",") ??
        (activeRates.length > 0 ? [activeRates[0].id] : []);

    const labelLineTypes = "Тип комнаты";
    const labelLineRates = "Тариф";
    const classMargin = { margin: "0 10px" };
    const flex = {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
    };
    const inputDate = {
        margin: "10px",
        backgroundColor: "#26ade4",
        color: "white",
        border: "none",
        outline: "none",
        borderRadius: "5px",
        padding: "10px",
        fontFamily: "Roboto",
        fontSize: "15px",
    };

    const disable = props.id > 0;

    return (
        <Box>
            <form
                onSubmit={props.addBan}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                }}
            >
                <Box>
                    <Box style={classMargin}>
                        <InputLabel>{labelLineTypes}</InputLabel>
                        <Select
                            style={{
                                border: "1px solid #8080804d",
                                borderRadius: "5px",
                                padding: "7px",
                                width: "320px",
                            }}
                            id="roomType"
                            label={labelLineTypes}
                            multiple
                            defaultValue={firstRoomTypeId}
                            onChange={disable ? () => {} : props.onChange}
                            renderValue={(selected) => {
                                return selected
                                    .map(
                                        (value) =>
                                            activeRoomTypes.find(
                                                (roomType) =>
                                                    roomType.id === +value,
                                            )?.name,
                                    )
                                    .join(", ");
                            }}
                            MenuProps={{
                                PaperProps: {
                                    style: {
                                        pointerEvents: disable
                                            ? "none"
                                            : "auto",
                                    },
                                },
                            }}
                        >
                            {activeRoomTypes.map((roomType, rtIdx) => (
                                <MenuItem
                                    key={`roomTypeOpt ${rtIdx}`}
                                    value={roomType.id}
                                >
                                    {roomType.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                    <div style={flex}>
                        <input
                            className={banStyles.banCheckbox}
                            style={classMargin}
                            disabled={disable}
                            defaultChecked={props.data.forAllTypes}
                            type="checkbox"
                            id="forAllTypes"
                        />
                        <label
                            style={classMargin}
                            htmlFor={!disable ? "forAllTypes" : "false"}
                        >
                            <h4>Для всех категорий</h4>
                        </label>
                    </div>
                </Box>

                <Box>
                    <Box style={classMargin}>
                        <InputLabel>{labelLineRates}</InputLabel>
                        <Select
                            style={{
                                border: "1px solid #8080804d",
                                borderRadius: "5px",
                                padding: "7px",
                                width: "320px",
                            }}
                            id="rates"
                            label={labelLineRates}
                            multiple
                            defaultValue={firstRateId}
                            onChange={disable ? () => {} : props.onChange}
                            renderValue={(selected) => {
                                return selected
                                    .map(
                                        (value) =>
                                            activeRates.find(
                                                (rate) => rate.id === +value,
                                            )?.name,
                                    )
                                    .join(", ");
                            }}
                            MenuProps={{
                                PaperProps: {
                                    style: {
                                        pointerEvents: disable
                                            ? "none"
                                            : "auto",
                                    },
                                },
                            }}
                        >
                            {activeRates.map((rate, rtIdx) => (
                                <MenuItem
                                    key={`rateOpt ${rtIdx}`}
                                    value={rate.id}
                                >
                                    {rate.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                    <div style={flex}>
                        <input
                            className={banStyles.banCheckbox}
                            style={classMargin}
                            disabled={disable}
                            defaultChecked={props.data.forAllRates}
                            type="checkbox"
                            id="forAllRates"
                        />
                        <label
                            style={classMargin}
                            htmlFor={!disable ? "forAllRates" : "false"}
                        >
                            <h4>Для всех тарифов</h4>
                        </label>
                    </div>
                </Box>
                <div style={flex}>
                    <input
                        className={banStyles.banCheckbox}
                        style={classMargin}
                        disabled={disable}
                        defaultChecked={props.data.closeIn}
                        type="checkbox"
                        id="close_in"
                    />
                    <label
                        style={classMargin}
                        htmlFor={!disable ? "close_in" : "false"}
                    >
                        <h4>Запретить заезд</h4>
                    </label>

                    <input
                        className={banStyles.banCheckbox}
                        style={classMargin}
                        disabled={disable}
                        defaultChecked={props.data.closeOut}
                        type="checkbox"
                        id="close_out"
                    />
                    <label
                        style={classMargin}
                        htmlFor={!disable ? "close_out" : "false"}
                    >
                        <h4>Запретить выезд</h4>
                    </label>
                </div>
                <div style={flex}>
                    <input
                        style={inputDate}
                        disabled={disable}
                        defaultValue={props.data.dateCloseStart}
                        type="date"
                        id="date_close_start"
                    />
                    <label
                        style={classMargin}
                        htmlFor={!disable ? "date_close_start" : "false"}
                    >
                        Дата начала
                    </label>
                </div>
                <div style={flex}>
                    <input
                        style={inputDate}
                        disabled={disable}
                        defaultValue={props.data.dateCloseEnd}
                        type="date"
                        id="date_close_end"
                    />
                    <label
                        style={classMargin}
                        htmlFor={!disable ? "date_close_end" : "false"}
                    >
                        Дата окончания
                    </label>
                </div>
                <input type="text" id={props.id} style={{ display: "none" }} />
                <div style={flex}>
                    {props.id == 0 ? (
                        <Button
                            color="primary"
                            variant="contained"
                            endIcon={<SaveIcon />}
                            style={{
                                backgroundColor: green[500],
                                margin: "10px",
                            }}
                            type="submit"
                        >
                            Добавить
                        </Button>
                    ) : (
                        <Button
                            onClick={() => props.deleteBan(props.id)}
                            color="primary"
                            variant="contained"
                            endIcon={<DeleteIcon />}
                            style={{
                                backgroundColor: red[500],
                                margin: "10px",
                            }}
                        >
                            Удалить
                        </Button>
                    )}
                </div>
            </form>
        </Box>
    );
};

export default BanArrivals;
